import React from 'react';

export const envs = [
    'local',
    'staging',
    'production',
];

export const EnvContext = React.createContext('local');
